import { IfpLoansDropdownWizardData } from '@sec-loans-ui/common/steps/assistance-step/components/ifp-loans-dropdown/IfpLoansDropdown'
import { IfpLoan } from '@shared/sec-loans'
import { useLanguage } from '@ui-common/hooks'
import { formatFinnishCurrencyWithSymbol } from '@ui-common/utils'
import { ExtraTightSectionContent } from '@ui-components/containers/ExtraTightSectionContent'
import { TertiaryHeading } from '@ui-components/typography/headings/TertiaryHeading'
import { BodyText, LabelText } from '@ui-components/typography/Typography'
import { useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'

export const SingleLoanView = ({ ifpLoan }: { ifpLoan: IfpLoan }) => {
  const { formatMessage } = useIntl()
  const { register } = useFormContext<IfpLoansDropdownWizardData>()
  const { currentLang } = useLanguage()

  register('selectedLoanUuid')

  return (
    <ExtraTightSectionContent>
      <LabelText>{formatMessage({ id: 'loans-assistance-ifp-loans-type-label' })}</LabelText>
      <TertiaryHeading header={ifpLoan.description[currentLang]} />
      <BodyText>{ifpLoan.iban}</BodyText>
      <BodyText>{formatFinnishCurrencyWithSymbol(ifpLoan.balance)}</BodyText>
    </ExtraTightSectionContent>
  )
}
